/* المِجْمَر — زر «أضف للسلة» على بطاقات الأصناف (2026-10-16، بطلب جامد).
   يضيف قطعة وحدة من أصغر وحدة متوفرة للصنف، وهي نفسها الوحدة والسعر المكتوبين على البطاقة:
   العود تولة، الأدهان ربع تولة، العطور الزجاجة.
   ما يحتاج تعديل قوالب البطاقات: يدوّر على a.mj-pc و a.mj-pfc ويضيف الزر داخل سطر «شوف …».
   بيانات الصنف تُجلب من /products/<handle>.js بس لحظة الضغط. البطاقات النافدة (.rsold) ما ينضاف لها زر. */
(function () {
  if (window.__mjqa) return; window.__mjqa = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M12 10v6M9 13h6"/></svg>';
  var LABEL = ICON + '<span class="t">أضف<span class="t-l"> للسلة</span></span>';
  var live = null;

  function say(msg) {
    if (!live) { live = document.createElement('div'); live.className = 'mj-qa-live'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30);
  }
  function inject(root) {
    (root || document).querySelectorAll('a.mj-pc, a.mj-pfc').forEach(function (a) {
      if (a.__qa) return; a.__qa = 1;
      if (a.querySelector('.rsold')) return;
      var go = a.querySelector('.go'); if (!go || go.querySelector('.mj-qa')) return;
      var nm = a.querySelector('.nm, h3'); var name = nm ? nm.textContent.trim() : '';
      var b = document.createElement('span');
      b.className = 'mj-qa'; b.setAttribute('role', 'button'); b.tabIndex = 0;
      b.setAttribute('aria-label', 'أضف للسلة: ' + name);
      b.innerHTML = LABEL;
      go.appendChild(b);
    });
  }
  function handleOf(a) {
    var m = decodeURIComponent(a.pathname).match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function flash(btn, cls, html, ms) {
    btn.classList.remove('is-ok', 'is-err'); btn.classList.add(cls); btn.innerHTML = html;
    clearTimeout(btn.__t);
    btn.__t = setTimeout(function () { btn.classList.remove(cls); btn.innerHTML = LABEL; }, ms || 2400);
  }
  function badge(n) {
    var cart = document.querySelector('header a[href$="/cart"], a[href$="/cart"][aria-label]');
    if (!cart) return;
    var b = cart.querySelector('.mj-badge');
    if (!b && n > 0) { b = document.createElement('span'); b.className = 'mj-badge'; cart.appendChild(b); }
    if (!b) return;
    b.textContent = n; b.hidden = n < 1;
    b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
  }
  function add(btn) {
    var a = btn.closest('a'); if (!a || btn.__busy) return;
    var h = handleOf(a); if (!h) { location.href = a.href; return; }
    btn.__busy = true; btn.classList.add('is-busy');
    fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })
          .sort(function (x, y) { return x.price - y.price; })[0];
        if (!v) { flash(btn, 'is-err', '<span class="t">نفدت الكمية</span>'); say('نفدت الكمية'); throw 1; }
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) { flash(btn, 'is-err', '<span class="t">ما في كمية أكثر</span>'); say('ما في كمية أكثر من هذا الصنف'); throw 1; }
          return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r2) { return r2.json(); });
        }).then(function (c) {
          badge(c.item_count);
          var unit = (v.public_title || v.title || '').replace(/Default Title/, '').trim();
          flash(btn, 'is-ok', '<span class="t">انضاف' + '<span class="t-l"> للسلة</span></span>');
          say('انضاف للسلة: ' + (p.title || '') + (unit ? '، ' + unit : ''));
        });
      })
      .catch(function (e) { if (e !== 1) { flash(btn, 'is-err', '<span class="t">صار خطأ</span>'); say('صار خطأ، جرّب مرة ثانية'); } })
      .then(function () { btn.__busy = false; btn.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mj-qa');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    add(btn);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.mj-qa');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    add(btn);
  }, true);

  function start() {
    inject();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(inject, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* مسار التصفح بنفس شكل صفحة الصنف في الموقع كله (بطلب جامد 2026-10-16):
   زر «رجوع» بدائرة سهم ← فاصل ← الرئيسية › … › الصفحة الحالية.
   يحوّل كل nav.mj-crumbs و nav.crumbs (ما عدا صفحة الصنف لأنها جاهزة) — المحتوى نفسه، الشكل بس.
   «رجوع» يرجع للصفحة السابقة لو جيت من داخل الموقع، وإلا يروح للصفحة الأم في المسار. */
(function () {
  if (window.__mjbc) return; window.__mjbc = 1;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function build(nav) {
    if (nav.__bc || nav.closest('.rawh-pp') || nav.querySelector('.rawh-cbk')) return; nav.__bc = 1;
    var items = [];
    [].forEach.call(nav.childNodes, function (n) {
      if (n.nodeType !== 1) return;
      var t = n.textContent.replace(/\s+/g, ' ').trim(); if (!t || t === '/') return;
      items.push({ t: t, h: n.tagName === 'A' ? n.getAttribute('href') : null });
    });
    if (items.length < 2) return;
    var parent = null;
    for (var i = items.length - 2; i >= 0; i--) if (items[i].h) { parent = items[i].h; break; }
    parent = parent || '/';
    var SEP = '<span class="sep" aria-hidden="true">/</span>';
    var html = '<a class="rawh-cbk" href="' + esc(parent) + '"><span class="ar" aria-hidden="true">→</span> رجوع</a>';
    html += items.map(function (it, k) {
      var last = k === items.length - 1;
      return (k ? SEP : '') + (it.h && !last ? '<a href="' + esc(it.h) + '">' + esc(it.t) + '</a>' : '<span' + (last ? ' aria-current="page"' : '') + '>' + esc(it.t) + '</span>');
    }).join('');
    nav.innerHTML = html;
    nav.classList.add('mj-bc');
    var back = nav.querySelector('.rawh-cbk');
    back.addEventListener('click', function (e) {
      try {
        var r = document.referrer ? new URL(document.referrer) : null;
        if (r && r.origin === location.origin && r.pathname !== location.pathname && history.length > 1) { e.preventDefault(); history.back(); }
      } catch (er) {}
    });
  }
  function run() { document.querySelectorAll('nav.mj-crumbs, nav.crumbs').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
